import React, {useEffect} from 'react'
import {Grid, Form, Item, Button, Loader} from 'semantic-ui-react'
import {connect} from "react-redux";
import store from "../../../actions/configureStore";
import SplitClient from "../../../utils/splitClient";
import * as sessionHelpers from "../../../helpers/sessionHelpers";

class ChecklistTooltip extends React.Component {
  onChange(val) {
    this.setState({ internalNotes: val })
  }

  componentDidMount() {
    async function loadShopOrderDetails() {
      const treatment = await SplitClient.getTreatment("SHOP_ORDERS",{ email: sessionHelpers.getApplicationCookie('current_user_email') })

      if (!this.props.orderDetails && treatment["SHOP_ORDERS"] === 'V2') {
        store.dispatch({
          type: 'SHOP_ORDER_LOAD_SAGA',
          payload: {id: this.props.order.id}
        })
      }
    }
    loadShopOrderDetails()
  }

  render() {
    const marginTop = { marginTop: "15px" }
    const { name, checked, internalNotes, handleSubmit, handleCancel, isLoading } = this.props
    if (isLoading) {
      return <Loader active={isLoading}/>
    }
    return (
      <div>
        <Grid style={{width: "480px"}}>
          <Grid.Column width='4'>
            <Item><strong>{name}:</strong></Item>
          </Grid.Column>
          <Grid.Column width='12'>
            <Item>{checked === true ? 'True' : 'False'}</Item>
          </Grid.Column>
        </Grid>

        <Form onSubmit={handleSubmit}>
          <div style={marginTop}>
            <textarea
              value={internalNotes}
              rows="10"
              style={{width: "460px"}}
              onChange={(e) => this.props.handleChange(e.target.value)}
            >
            </textarea>
          </div>
          <div style={marginTop}>
            <Button primary type="submit" value="Filter">Submit</Button>
            <Button secondary type="button" value="Filter" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
          <div style={{marginTop: "10px"}}>
            <small>* Changes to "{name}" will not be saved until submitted</small>
          </div>
        </Form>
      </div>
    )
  }
}
const mapStateToProps = (state, props) => {
  const orderDetails = state.shopOrders && state.shopOrders.orderDetails;
  return {
    orderDetails: orderDetails && orderDetails[props.order.id] ? orderDetails[props.order.id] : null,
    isLoading: state.application.isTooltipLoading
  }
}

export default connect(mapStateToProps)(ChecklistTooltip)
